import type { RouteObject } from 'react-router';

import { lazyComponent } from '../../../lazy-component';
import { usersLoader } from './users-loader';

export const usersRoutes: RouteObject = {
  loader: usersLoader,
  children: [
    {
      path: '/admin/users/list',
      lazy: lazyComponent(() => import('@pages/tenant/users'), 'UsersPage'),
    },
    {
      path: '/admin/users/roles',
      lazy: lazyComponent(() => import('@pages/tenant/users'), 'UsersRoles'),
    },
  ],
};
